import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Form, Button } from "antd";
import {
    formHasErrors,
    getErrorOnField,
    submitForm,
    fieldGenerator
} from "utilities/form";
import { FORGOT_NEW_PASSWORD_FORM } from "constants";
import "styles/form.css";

const createFormField = Form.createFormField;
const FormItem = Form.Item;

class ForgotNewPasswordForm extends React.Component {
    hasErrors = formHasErrors.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    handleFormSubmit = submitForm.bind(this.props.form, values =>
        this.props.submitValues(values)
    );
    fieldGenerator = fieldGenerator.bind(this.props.form);
    render() {
        return (
            <Form
                onSubmit={this.handleFormSubmit}
                className={cx("form", "br-3")}
            >
                {FORGOT_NEW_PASSWORD_FORM.map((field, fieldName) =>
                    this.fieldGenerator(
                        fieldName,
                        field,
                        this.getErrorOnField(fieldName)
                    )()
                )
                    .toList()
                    .toJS()}
                <FormItem>
                    <Button type="primary" block htmlType="submit">
                        Next
                    </Button>
                </FormItem>
            </Form>
        );
    }
}

ForgotNewPasswordForm.defaultProps = {
    formSubmitting: false
};

ForgotNewPasswordForm.propTypes = {
    id: PropTypes.string,
    values: PropTypes.object,
    errors: PropTypes.object,
    form: PropTypes.object,
    formSubmit: PropTypes.func,
    formSubmitting: PropTypes.bool,
    submitValues: PropTypes.func
};

export default Form.create({
    mapPropsToFields: ({ values, errors }) => {
        if (values && values.size) {
            return values
                .map((_, fieldName) =>
                    createFormField({
                        value: _,
                        errors: errors && errors.get(fieldName)
                    })
                )
                .toJS();
        }
    }
})(ForgotNewPasswordForm);
